import { useContext } from "react";
import { MdCall, MdLocationOn, MdMail } from "react-icons/md";
import { AppContext } from "../App";
import { getCurrentYear } from "../Helpers";
import logo from "../assets/logo.png";
import { projects } from "./ProjectsContent";
import { serviceCategories } from "./ServicesContent";

export const snjContact = {
  email: "info@snj.co.tz",
  phone: "+255 713 555 092",
  phoneAlt: "+255 713 555 093",
  location: "Ubungo NHC, Dar es Salaam, Tanzania",
  postal: "P.O. Box 54410",
  office: "SNJ Tanzania Limited Head Office",
};

const menuLinks = [
  { label: "Home", nav: { item: "home" } },
  { label: "About", nav: { item: "about_us", subItem: "overview" } },
  { label: "Services", nav: { item: "services" } },
  { label: "Projects", nav: { item: "projects" } },
  { label: "Contacts", nav: { item: "contact_us" } },
];

export default function Footer() {
  const appContext = useContext(AppContext);

  return (
    <footer className="tgm-footer">
      <div className="container">
        <div className="tgm-footer-grid">
          <div className="tgm-footer-brand-block">
            <img src={logo} alt="SNJ Tanzania Limited" />
            <p>
              SNJ Tanzania Limited provides building and civil engineering
              solutions from its head office in Dar es Salaam, Tanzania.
            </p>
            <div className="tgm-footer-contact-icons">
              <a href={`tel:${snjContact.phone.replace(/\s/g, "")}`} aria-label="Call SNJ Tanzania">
                <MdCall />
              </a>
              <a href={`mailto:${snjContact.email}`} aria-label="Email SNJ Tanzania">
                <MdMail />
              </a>
              <button
                type="button"
                aria-label="Open contact page"
                onClick={() => appContext.navTo({ item: "contact_us" })}
              >
                <MdLocationOn />
              </button>
            </div>
          </div>

          <div>
            <span className="tgm-footer-label">Menu</span>
            {menuLinks.map((link) => (
              <button
                type="button"
                key={link.label}
                onClick={() => appContext.navTo(link.nav)}
              >
                {link.label}
              </button>
            ))}
          </div>

          <div>
            <span className="tgm-footer-label">Projects</span>
            {projects.slice(0, 6).map((project) => (
              <button
                key={project.slug}
                type="button"
                onClick={() =>
                  appContext.navTo({
                    item: "projects",
                    subItem: project.slug,
                  })
                }
              >
                {project.name}
              </button>
            ))}
          </div>

          <div>
            <span className="tgm-footer-label">Services</span>
            {serviceCategories.map((service) => (
              <button
                key={service.slug}
                type="button"
                onClick={() =>
                  appContext.navTo({
                    item: "services",
                    subItem: service.slug,
                  })
                }
              >
                {service.title}
              </button>
            ))}
          </div>
        </div>

        <div className="tgm-footer-bottom">
          <p>&copy; {getCurrentYear()} SNJ Tanzania Limited</p>
          <p>Website designed by&nbsp;
          <a
            className="werenium"
            href="https://werenium.com"
            target="_blank"
            rel="noreferrer"
          >
            Werenium Technologies
          </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
